import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const DataContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const TopData = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

export const BottomData = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

export const DifferenceValue = styled.div`
  font-size: 40px;
  font-weight: 500;
  color: ${colors.amber};
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
`;
